import styled from "styled-components";
import { dashboardTheme } from "./theme/dashboardTheme";

export const DashboardContainer = styled.div`
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
  background: ${dashboardTheme.colors.background};
  min-height: 100vh;
`;

export const Main = styled.main<{ $loading: boolean; $hasData: boolean }>`
  background: ${dashboardTheme.colors.background};
  width: 100%;
  min-height: 100vh;
`;

export const Section = styled.section`
  min-height: 60vh;
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobileSm}) {
    padding: 0.625rem 0.625rem 1.25rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileSm}) and (max-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    padding: 0.75rem 0.75rem 1.5rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    padding: 0.875rem 1rem 2rem;
  }
`;

export const DashboardGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${dashboardTheme.spacing.desktopGap};
  margin-top: 0.25rem;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    gap: ${dashboardTheme.spacing.mobileGap};
  }
`;

export const UserInfoRow = styled.div`
  box-sizing: border-box;
  width: 100%;
`;

export const VisitsOffersRow = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${dashboardTheme.spacing.desktopGap};
  width: 100%;
  align-items: stretch;
  min-height: 20rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    grid-template-columns: 1fr;
    gap: ${dashboardTheme.spacing.mobileGap};
    min-height: auto;
  }
`;

export const ChartFullRow = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
`;

export const PatrimonyRow = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
`;

export const PropertyAnalyticsRow = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
`;

export const PendingSignaturesRow = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
`;

export const VisitsWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  height: 100%;

  & > * {
    flex: 1;
    width: 100%;
    height: 100%;
  }
`;

export const PaymentsWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
`;

export const PortfolioRow = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;

  &:empty {
    display: none;
  }
`;

export const RentedPropertiesRow = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;

  &:empty {
    display: none;
  }
`;

export const AvailablePropertiesRow = styled.div`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;

  &:empty {
    display: none;
  }
`;

export const OffersWrapper = styled.div`
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;

  & > * {
    flex: 1;
    width: 100%;
    height: 100%;
  }
`;

export const NoDataGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    flex-direction: column;
    gap: ${dashboardTheme.spacing.mobileGap};
  }
`;

export const NoDataLeft = styled.div`
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    width: 30%;
  }
`;

export const NoDataRight = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 1;
  align-items: center;
  color: ${dashboardTheme.colors.textPrimary};

  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    flex-direction: row;
  }
`;

export const NoDataTitle = styled.h2`
  margin: 0 0 0.8rem;
  color: ${dashboardTheme.colors.textPrimary};
  font-size: ${dashboardTheme.typography.sectionTitle};
  font-weight: 700;
`;

export const NoDataText = styled.p`
  margin: 0;
  color: ${dashboardTheme.colors.textSecondary};
  font-size: ${dashboardTheme.typography.body};
  line-height: 1.6;
`;

export const NoDataTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NoDataImage = styled.img<{ $stacked: boolean }>`
  margin: 16px 0;
  width: ${({ $stacked }) => ($stacked ? "100%" : "50%")};
  max-width: 100%;
`;

export const AdvertisePropertySection = styled.div`
  box-sizing: border-box;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLg}) {
    order: 10;
  }
`;

export const OwnerExclusiveServicesSection = styled.div`
  box-sizing: border-box;
  width: 100%;
`;
